import api from "../api";
import {iniciarRequisicao, logout} from "../../helpers";
import {STATUS_HTTP} from "../statusHTTP";

const BASE_URI = '/pedidos-compra/categorias';

export const adicionarCategoriaNoCarrinho = async (requisicao) => {
  const {data, status} = await api.post(BASE_URI, requisicao, {headers: iniciarRequisicao()}).catch(() => logout());

  if (status === STATUS_HTTP.OK) {
    localStorage.token = data.token;
    return data.pedidos;
  }

  logout();
}

export const editarCategoriaNoPedido = async (requisicao) => {
  const config = {
    headers: iniciarRequisicao()
  };

  const url = `/pedidos-compra/categorias`;

  const {data, status} = await api.put(url, requisicao, config).catch(() => logout());

  if (status === STATUS_HTTP.OK) {
    localStorage.token = data.token;
    return data.resultado;
  }

  logout();
}

export const excluirCategoriaDoPedido = async (categoria) => {
  const config = {
    headers: iniciarRequisicao(),
    params: categoria
  };

  const {data, status} = await api.delete(BASE_URI, config).catch(() => logout());

  if (status === STATUS_HTTP.OK) {
    localStorage.token = data.token;
    return data.resultado;
  }

  logout();
}

